export enum InstructorType {
  SeniorGolfPro = 'Sr. Golf Pro',
  GolfPro = 'Golf Pro',
  AssociateGolfPro = 'Associate Golf Pro',
}
